import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getPromotionsStart,
  getPromotionsSuccess,
  getPromotionsFailed,
  getSinglePromoStart,
  getSinglePromoSuccess,
  getSinglePromoFailed,
  getSingleTemplateStart,
  getSingleTemplateSuccess,
  getSingleTemplateFailed,
  getMetadataStart,
  getMetadataSuccess,
  getMetadataFailed,
  getRequestedCustomPromotionsStart,
  getRequestedCustomPromotionsSuccess,
  getRequestedCustomPromotionsFailed,
  cancelPromoFailed,
  cancelPromoStart,
  cancelPromoSuccess,
  createPromoByTemplateStart,
  createPromoByTemplateSuccess,
  createPromoByTemplateFailed,
  reschedulePromoStart,
  reschedulePromoSuccess,
  reschedulePromoFailed
} from 'redux/actions/promo';
import {
  getGlobalLibraryStart,
  getGlobalLibrarySuccess,
  getGlobalLibraryFailed,
  getMyLibraryStart,
  getMyLibrarySuccess,
  getMyLibraryFailed,
  deleteSingleTemplateStart,
  deleteSingleTemplateSuccess,
  deleteSingleTemplateFailed,
  downloadGlobalLibraryTemplateStart,
  downloadGlobalLibraryTemplateSuccess,
  downloadGlobalLibraryTemplateFailed,
} from 'redux/actions/library';
import { parseErrorMessage, serialize } from '../helpers/api';


export const getPromotionsAPI = async ({ dispatch, page = '1', limit = '20', status = 'All', sorting = 'desc', name = '', labelsIds = '' }) => {
  try {
    dispatch(getPromotionsStart());
    const params = new URLSearchParams({
      page,
      limit,
      name,
      status,
      sorting,
      labelsIds
    }).toString();
    const { data } = await api.get(`${shopManagerApi}/promotool/promotions?${params}`);
    dispatch(getPromotionsSuccess(data, status));
  } catch (e) {
    dispatch(getPromotionsFailed());
  }
};

export const getSinglePromotionAPI = async ({ dispatch, id }) => {
  try {
    dispatch(getSinglePromoStart());
    const { data } = await api.get(`${shopManagerApi}/promotool/promotions/${id}`);
    dispatch(getSinglePromoSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(getSinglePromoFailed(message));
  }
};

export const getSingleTemplateAPI = async ({ dispatch, id }) => {
  try {
    dispatch(getSingleTemplateStart());
    const { data } = await api.get(`${shopManagerApi}/promotool/library/${id}`);
    dispatch(getSingleTemplateSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(getSingleTemplateFailed(message));
  }
};

export const deleteSingleTemplateAPI = async ({dispatch, id}) => {
  try {
    dispatch(deleteSingleTemplateStart());
    const { data } = await api.delete(`${shopManagerApi}/promotool/library/${id}`);
    dispatch(deleteSingleTemplateSuccess(id, data));
  } catch (e) {
    dispatch(deleteSingleTemplateFailed());
  }
};

export const cancelPromotionAPI = async ({ dispatch, id }) => {
  try {
    dispatch(cancelPromoStart(id));
    const { data } = await api.patch(`${shopManagerApi}/promotool/promotions/${id}/discard`);
    dispatch(cancelPromoSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(cancelPromoFailed(message, id));
  }
};

export const reschedulePromotionAPI = async ({ dispatch, id, startDate, endDate }) => {
  try {
    dispatch(reschedulePromoStart(id));
    const { data } = await api.post(`${shopManagerApi}/promotool/promotion/${id}/reschedule`, {startDate, endDate});
    dispatch(reschedulePromoSuccess(data));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(reschedulePromoFailed(message, id));
  }
};

export const getGlobalLibraryAPI = ({ limit = 10, ...rest }) => async (dispatch) => {
  try {
    dispatch(getGlobalLibraryStart());
    const filterObj = {
      limit,
      sorting: 'desc',
      ...rest
    };

    const { data } = await api.get(`${shopManagerApi}/promotool/global-library${serialize(filterObj)}`);
    dispatch(getGlobalLibrarySuccess(data));
  } catch (e) {
    dispatch(getGlobalLibraryFailed());
  }
};

export const downloadGlobalLibraryTemplateAPI = async ({ dispatch, templateId }) => {
  try {
    dispatch(downloadGlobalLibraryTemplateStart());
    const { data } = await api.post(`${shopManagerApi}/promotool/global-library/${templateId}/download`);
    dispatch(downloadGlobalLibraryTemplateSuccess(data, templateId));
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(downloadGlobalLibraryTemplateFailed(message));
  }
};

export const getMyLibraryAPI = ({ page = '1', limit = '20', sorting = 'desc', name = '', labelsIds = ''  }) => async (dispatch) => {
  try {
    dispatch(getMyLibraryStart());
    const params = new URLSearchParams({
      page,
      limit,
      name,
      sorting,
      labelsIds,
      myLibrary: 'true'
    }).toString();

    const { data } = await api.get(`${shopManagerApi}/promotool/library?${params}`);
    dispatch(getMyLibrarySuccess(data));
  } catch (e) {
    dispatch(getMyLibraryFailed());
  }
};

export const createPromoByTemplateAPI = async ({ dispatch, id, startDate, endDate }) => {
  try {
    dispatch(createPromoByTemplateStart(id));
    const { data } = await api.post(`${shopManagerApi}/promotool/promotions/${id}`, { startDate, endDate });
    dispatch(createPromoByTemplateSuccess(data));
    return true;
  } catch (e) {
    const message = parseErrorMessage(e);
    dispatch(createPromoByTemplateFailed(message, id));
    return false;
  }
};

export const getMetadataAPI = async ({ dispatch, usedIn }) => {
  try {
    dispatch(getMetadataStart());
    const params = new URLSearchParams({ usedIn }).toString();
    const { data } = await api.get(`${shopManagerApi}/promotool/meta_data?${params}`);
    dispatch(getMetadataSuccess(data));
  } catch (e) {
    dispatch(getMetadataFailed(e));
  }
};

export const getRequestedCustomPromotionsApi = async ({ dispatch, page, limit, type }) => {
  try {
    dispatch(getRequestedCustomPromotionsStart());
    const params = new URLSearchParams({
      page,
      limit,
      type
    }).toString();
    const { data } = await api.get(`${shopManagerApi}/user/requests?${params}`);
    dispatch(getRequestedCustomPromotionsSuccess(data));
  } catch (e) {
    dispatch(getRequestedCustomPromotionsFailed());
  }
};
